export const sendEventLog = (name, log) => {
  //FS (full story)
  const fsClient = window.FS;
  const sessionId = localStorage?.getItem("sessionId") || "";
  const companyName = localStorage?.getItem("companyName") || "";
  log["session_id_str"] = sessionId;
  log["customer_type_str"] = companyName;

  if (fsClient && typeof fsClient.event === "function") {
    try {
      fsClient.event(name, log);
      console.log(
        `%c Success on fs.event - ${name} `,
        "background-color: tomato; color: #000"
      );
    } catch (ex) {
      console.log(
        `%c Exception on fs.event - ${name} `,
        "background-color: red; color: #000"
      );
    }
  } else {
    console.log(
      `%c fs not found - ${name} `,
      "background-color: red; color: #000"
    );
  }
};
